import React, { useEffect, useState } from 'react';
import './StatisticsSection.css';
import { FaUserGraduate, FaBriefcase , FaUserFriends, FaCertificate } from 'react-icons/fa';

const StatisticsSection = () => {
  const [experience, setExperience] = useState(0);
  const [interns, setInterns] = useState(0);
  const [patients, setPatients] = useState(0);
  const [certificates, setCertificates] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const countToValue = (targetValue, setState) => {
      let currentCount = 0;
      const increment = targetValue / 100;
      const interval = setInterval(() => {
        currentCount += increment;
        setState(Math.ceil(currentCount));
        if (currentCount >= targetValue) {
          clearInterval(interval);
        }
      }, 10);
    };

    if (isVisible) {
      countToValue(4, setExperience);
      countToValue(25, setInterns);
      countToValue(10000, setPatients);
      countToValue(16, setCertificates);
    }
  }, [isVisible]);

  const handleIntersection = (entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5,
    });
    const target = document.querySelector('.statistics-section');
    observer.observe(target);

    return () => {
      observer.unobserve(target);
    };
  }, []);

  return (
    <section className="statistics-section">
      <div className="statistics-container">
        <div className="statistics">
          
          <div className="statistic">
            <FaUserFriends className="statistic-icon" />
            <h3>Patients</h3>
            <p>{patients}+</p>
          </div>

          <div className="statistic">
            <FaBriefcase className="statistic-icon" />
            <h3>Experience</h3>
            <p>{experience} years of experience</p>
          </div>

          <div className="statistic">
            <FaCertificate className="statistic-icon" />
            <h3>Quality Certificates</h3>
            <p>{certificates}</p>
          </div>

          <div className="statistic">
            <FaUserGraduate className="statistic-icon" />
            <h3>Interns/students</h3>
            <p>{interns}</p>
          </div>


        </div>
      </div>
      <div className="founder-section">
          <div className="founder-photo"></div>
          <div className="founder-quote">
            <h2>Message from the Founder</h2>
            <p>"At Nisha's Dental Care, we are committed to providing the highest quality dental care to our patients. Our team of experienced dentists and staff strive to create a comfortable and welcoming environment for all."</p>
          </div>
        </div>
    </section>
  );
};

export default StatisticsSection;
